import React, { useCallback, useContext,  useState } from 'react'
import { TableBody, TableRow, TableCell, Stack,  Collapse, Table, Link } from '@mui/material';
import { COLOR_MAP } from '../../../../constants/ColorNames';
import CampaignName from './CampaignName';
import CampaignStages from './CampaignStages';
import styled from '@emotion/styled';
import { useGetCampaignStageDetailsQuery } from '../../../../redux/services/folderName';
import { CampaignListDataType, ConfigureMailDataType } from '../../../../types/dataTypes';
import { ToastContext } from '../../../../utils/context/toastContext';
import { DropDown } from '../../../../constants/icons/DropDown';
import { DropUp } from '../../../../constants/icons/DropUp';
import Schedule from './Schedule';
import { TABLE_CONSTANTS } from '../../constants';
import CampaignStageDetails from './CampaignStageDetails';
import { extractDomain } from '../../../../utils/helpers';
import { useHover } from "@uidotdev/usehooks";
import ActionsMenu from './ActionsMenu';
import { useStartDownloadWhatsAppRepliesMutation } from '../../../../redux/services/campaignListingService';
import useDownloadWhatsAppReplies from '../../../../hooks/useFileDownload';
import { Button } from "@foundit/ui-library";
import { getCampaignUIStatus } from '../../../../utils/utils';



type TableContentProps = {
  isLast: boolean,
  campaignDetail: CampaignListDataType,
  selectedCampaignId: any,
  expanded: any[],
  setExpanded: React.Dispatch<React.SetStateAction<any>>
  revampServices?: {enabled: boolean}
  bannerRef: any,
  mailStripData?: ConfigureMailDataType
}


const PauseText = (fontColor: string) => styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  margin: 0;
  color: ${fontColor};
`
const FolderText = (fontColor: string) => styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 500;
  margin: 0;
  color: ${fontColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
  &:hover {
    color: ${COLOR_MAP.DARK_PURPLE}
  }
`;


export const GreenPassiveBox = styled.div`
  border-radius: 4px;
  background: ${COLOR_MAP.SECONDARY_GREEN};
  font-weight: 500;
`

const TableContent = (props: TableContentProps) => {
  const [hoverRefCollapsed, hoveringCollapsed] = useHover();
  const [hoverRefExpanded, hoveringOnExpanded] = useHover();
  const hovering = hoveringCollapsed || hoveringOnExpanded

  const { isLast, campaignDetail, expanded, setExpanded, bannerRef, mailStripData } = props
  const { id, status, createdAt, name, campaignType } = campaignDetail


  const [requestId, setRequestId] = useState<string>("");

  const { setToastValue } = useContext(ToastContext);
  const [triggerDownload] =
    useStartDownloadWhatsAppRepliesMutation();

  useDownloadWhatsAppReplies(requestId);

  const isWhatsAppCampaign = campaignDetail?.osType?.toLowerCase() === "whatsapp";


  const { data: campaignStageData, isLoading: campaignStageLoading } = useGetCampaignStageDetailsQuery({campaignId: campaignDetail.id, isWhatsAppStage: isWhatsAppCampaign});
  const {isBulkCampaign, triggeredFromPage , initiationId, timeZone, campaignId, searchId, pausedBy, marketyReason} = campaignStageData || {}

  const {status: finalStatus} = getCampaignUIStatus(campaignStageData?.status || status || "", campaignStageData?.subStatus || "")


  console.log({campaignStageData})
  const selectedColor = COLOR_MAP.DARK_PURPLE;
  const CustomInfoText = PauseText(selectedColor);
  
  const showPause = ['LIVE', 'PAUSED', 'SCHEDULED', 'AUTO_PAUSED'].includes(status);
  const showAbort = ['PAUSED', 'SCHEDULED', 'AUTO_PAUSED'].includes(status);
  const isExpanded = !!expanded.includes(id)
  
  const CustomFolderText = FolderText(hovering ? COLOR_MAP.DARK_PURPLE : COLOR_MAP.GREY_1);

  const handleInfoClick = () => {
    let arr = [...expanded]
    if (expanded.includes(id)) {
      arr.splice(expanded.indexOf(id), 1);
      setExpanded(arr)
    }
    else {
      setExpanded([...arr, id])
    }
  }

  const redirectToFolder = () => {
    const url = "recruiter-fm/folder-details";
    return(`${extractDomain()}/edge/${url}?campaignId=${campaignStageData?.campaignId||""}&campaign=${campaignStageData?.campaignName || ""}&folderID=${campaignStageData?.folderId}&autoMatch=${!!campaignStageData?.autoMatch}`)
  }

  const showDownloadErrorMsg = useCallback(() =>{
    setToastValue({
      isToastShown: true,
      toastMessage: "Failed to download excel. Please try again.",
      toastKey: "downloadFailedError",
      toastSeverity: "error",
    });
  },[setToastValue])

  const handleDownload = async ({campaignId}:{campaignId: string}) => {
    
    try {
      const response = await triggerDownload({campaignId}).unwrap();
      setRequestId(response?.requestId || ""); 
    } catch (err) {
      showDownloadErrorMsg();
    }
  }

  return (
    <>
      <TableRow
        key={id}
        sx={{
          borderBottom: 0,
          // backgroundColor: isSelectedCampaign ? `${COLOR_MAP.LIGHT_PURPLE}` : `${COLOR_MAP.WHITE}`,
          backgroundColor: hovering
            ? `${COLOR_MAP.LIGHT_PURPLE}`
            : `${COLOR_MAP.WHITE}`,
          display: "flex",
        }}
        ref={hoverRefCollapsed}
      >
        <CampaignName
          campaignName={name}
          campaignDate={createdAt}
          status={finalStatus}
          resumeAt={campaignStageData?.resumeAt || ""}
          reason={campaignStageData?.reason || ""}
          showHighlightedColor={hovering}
          campaignType={campaignType}
          isBulkCampaign={isBulkCampaign}
          triggeredFromPage={triggeredFromPage}
          initiationId={initiationId}
          timeZone={timeZone}
          campaignId={campaignId}
          searchId={searchId}
          pausedBy={pausedBy}
          marketyReason={marketyReason}
          isWhatsAppCampaign={isWhatsAppCampaign}
          campaignStageLoading={campaignStageLoading}
        />

        <CampaignStages
          isExpanded={isExpanded}
          isSelectedCampaign={hovering}
          campaignStageData={campaignStageData}
          isWhatsAppCampaign={isWhatsAppCampaign}
          revampServices={props?.revampServices}
        />

        <TableCell
          align="left"
          sx={{
            paddingTop: "2.4rem",
            paddingBottom: "1.6rem",
            flex: "1",
            borderBottom: isExpanded ? "inherit" : "none",
          }}
        >
          <Link
            className="primary"
            underline="hover"
            display={"inline-flex"}
            alignItems={"center"}
            href={redirectToFolder()}
            component="a"
            target="_blank"
            color={COLOR_MAP.DARK_PURPLE}
          >
            <CustomFolderText
              style={{ cursor: "pointer", width: "100%" }}
              onClick={redirectToFolder}
            >
              {campaignStageData?.folderName}
            </CustomFolderText>
          </Link>
        </TableCell>
        {!campaignStageLoading && (
          <TableCell
            align="left"
            sx={{
              paddingTop: "2.4rem",
              paddingBottom: "1.6rem",
              minWidth: "auto",
              borderBottom: isExpanded ? "inherit" : "none",
              display: "flex",
              gap: "12px",
            }}
          >
            <ActionsMenu
              handleDownload={handleDownload}
              campaignId={id}
              campaignName={name}
              status={finalStatus}
              rawStatus={status}
              isWhatsAppCampaign={isWhatsAppCampaign}
              bannerRef={bannerRef}
              mailStripData={mailStripData}
            />

            <Button
              onClick={handleInfoClick}
              type="text"
              size="small"
              sx={{ width: "32px", minWidth: "unset", padding: "0px" }}
            >
              {isExpanded ? (
                <DropUp stroke={selectedColor} />
              ) : (
                <DropDown stroke={selectedColor} />
              )}
            </Button>

            {/* <CustomInfoText>Info</CustomInfoText> */}
          </TableCell>
        )}
      </TableRow>
      <TableRow
        sx={{
          borderBottom: isLast ? 0 : `4px solid ${COLOR_MAP.GREY}`,
          backgroundColor: hovering
            ? `${COLOR_MAP.LIGHT_PURPLE}`
            : `${COLOR_MAP.WHITE}`,
        }}
        ref={hoverRefExpanded}
      >
        <TableCell colSpan={4} style={{ padding: "0" }}>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Table>
              <TableBody style={{ height: "142px", verticalAlign: "top" }}>
                <TableCell
                  style={{
                    width: `${TABLE_CONSTANTS.CAMPAIGN_NAME + 8}px`,
                    minWidth: `${TABLE_CONSTANTS.CAMPAIGN_NAME + 8}px`,
                  }}
                ></TableCell>
                <CampaignStageDetails
                  campaignStageData={campaignStageData}
                  isSelectedCampaign={hovering}
                  isWhatsAppCampaign={isWhatsAppCampaign}
                />
                <Schedule
                  campaignStageData={campaignStageData}
                  campaignDetail={campaignDetail}
                />
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
export default TableContent;

